import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  production: true,
  backend_url: 'https://api.coca.alzp.tgscloud.net',
  agGridLicenseKey: '',
  authentication: {
    clientId: '372b7f62-cdb6-4fff-a97f-0381d024fe6d',
    authority:
      'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e',
    scopes: ['api://399215e6-4dbf-4f65-9b83-0a10bdbcf79a/all'],
    redirectUri: '/home',
  },
  hotjarProjectId: 6456357,
  awsrum: {
    enabled: true,
    region: 'eu-central-1',
    guestRoleArn: 'arn:aws:iam::522288928413:role/RUM_write_unauthenticated',
    identityPoolId: 'eu-central-1:1c29d4c4-7b43-4ae2-aaa1-db6683e79ee9',
    applicationId: '3337e7ed-e61c-4761-9d70-258fef954e98',
  },
};
